import { imageStore } from '../images.js';
import Drawable from './Drawable.js';
import Sprite from '../ui/Sprite.js';

export default class HMRock extends Drawable {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
            visible: this.visible,
            destroyed: this.destroyed,
        };
    }

    static deserialize(data) {
        const hmRock = new HMRock({ position: data.position });
        hmRock.visible = data.visible;
        hmRock.destroyed = data.destroyed;
        return hmRock;
    }

    constructor({ position, OSM, GUI }) {
        super({ position });
        this.visible = true;
        this.sprite = new Sprite({
            position: this.position,
            image: imageStore.get('img/hm_rock.png'),
            moving: false,
            visible: this.visible,
            hold: 12,
            frames: {
                max: 4,
                val: 0,
            },
        });
        this.destroyed = false;
        this.OSM = OSM;
        this.GUI = GUI;
    }

    canInteract() {
        return !this.destroyed;
    }

    interact() {
        this.sprite.moving = true;
    }

    draw() {
        if (!this.visible) return;
        if (this.destroyed) {
            return;
        }

        if (this.sprite.frames.val === this.sprite.frames.max - 1) {
            this.sprite.moving = false;
            this.destroyed = true;
            this.visible = false;
        }

        this.sprite.position = this.effectivePosition();
        this.sprite.draw();
    }
}
